<template>
  <div>
    <v-row>
      <v-col cols='12' :sm="value.is_company ? '12' : '6'">
        <v-text-field :label="value.is_company ? 'Company name' : 'First Name'" :rules='[rules.required]' v-model='value.name'></v-text-field>
      </v-col>
      <v-col cols='12' sm='6' v-if='!value.is_company'>
        <v-text-field label='Last name' v-model='value.last_name'></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' sm='6'>
        <v-select label='Company or Individual?' :items='businessIndividualToggle' disabled v-model='value.is_company'></v-select>
      </v-col>
      <v-col cols='12' sm='6'>
        <v-checkbox hide-details v-model='value.snail_mail_only' label='Snail Mail Only?'></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <v-text-field label='Email' :rules='[rules.email]' v-model='value.email' prepend-icon='mdi-email'></v-text-field>
      </v-col>
      <v-col cols='12' sm='4' v-if='!value.is_company'>
        <phone-number-field 
          label='Home phone'
          :phone='value.home_phone !== null ? value.home_phone : ""'
          @update='updateHomePhone' 
          icon='mdi-phone-classic'
        ></phone-number-field>
      </v-col>
      <v-col cols='12' sm='4' v-if='!value.is_company'>
        <phone-number-field 
          label='Cell phone' 
          :phone='value.cell_phone !== null ? value.cell_phone : ""'
          @update='updateCellPhone' 
          icon='mdi-cellphone' 
        ></phone-number-field>
      </v-col>
      <v-col cols='12' sm='4'>
        <phone-number-field
          :label="value.is_company ? 'Main Phone' : 'Work phone'"
          :phone='value.work_phone !== null ? value.work_phone : ""'
          @update='updateWorkPhone'
          icon='mdi-deskphone'
        ></phone-number-field>
        <v-expand-transition>
          <div v-if='value.work_phone && !value.is_company'>
            <v-text-field label='Work Extension' v-model='value.work_phone_extension' prepend-icon='mdi-phone-plus' :rules='[rules.intOrEmpty]' hint='if applicable'></v-text-field>
          </div>
        </v-expand-transition>
      </v-col>
      <v-col cols='12' v-if='!value.is_company'>
        <client-form-search
          v-model='value.works_for'
          label='Works for'
          :company='true'
          @loading='setLoading'
        ></client-form-search>
      </v-col>
      <v-col cols='12' v-if='value.is_company'>
        <client-form-search
          v-model='value.main_contact'
          label='Main Contact'
          :company='false'
          @loading='setLoading'
        ></client-form-search>
      </v-col>
      <v-col cols='12' v-if='value.is_company'>
        <client-form-search
          v-model='value.ap_contact'
          label='Accounts Payable Contact'
          :company='false'
          @loading='setLoading'
        ></client-form-search>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import formRules from '@/mixins/formRules';
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch';
import PhoneNumberField from '@/components/forms/PhoneNumberField';

export default {
  name: 'client-basics-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
  data: () => ({
    businessIndividualToggle: [
      { text: 'Company', value: true },
      { text: 'Individual', value: false }
    ],
  }),
  methods: {
    setLoading (val) {
      this.$emit('loading', val)
    },
    updateHomePhone(phone){
      this.value.home_phone = phone;
    },
    updateCellPhone(phone){
      this.value.cell_phone = phone;
    },
    updateWorkPhone(phone){
      this.value.work_phone = phone;
    }
  },
  components: {
    'client-form-search': ClientFormSearch,
    'phone-number-field': PhoneNumberField
  }
}
</script>
